<template>
	<div
		class="ms-grid-viewer ms-tree-viewer"
		:class="[browserInfo && browserInfo.isFirefox ? 'overflow-auto' : '']"
	>
		<table class="ms-table--th">
			<thead
				class="ms-thead"
				:class="[
					{
						'ms-thead-firefox': browserInfo && browserInfo.isFirefox,
					},
				]"
			>
				<tr class="ms-tr">
					<ms-th
						v-for="(col, index) in columnx"
						:key="index"
						:col="col"
						class="ms-th"
					></ms-th>
				</tr>
			</thead>
		</table>
		<table class="ms-table--body">
			<div class="ms-content--table">
				<tbody
					v-if="dataView.length > 0 && !isNoData"
					:class="[{ 'overflow-y-auto': browserInfo && browserInfo.isFirefox }]"
				>
					<ms-tr
						v-for="(row, indexCol) in dataView"
						:key="`${indexCol}-${row.isHide}`"
						:dataRow="row"
						:columns="columnx"
						:isShowExpanded="isShowExpanded"
						v-on="listeners"
						@dataAction="handlerAction"
					></ms-tr>
				</tbody>
				<tbody v-if="isNoData">
					<tr class="ms-tr">
						<td class="no-data">{{ $t('i18nCommon.noData') }}</td>
					</tr>
				</tbody>
			</div>
		</table>
	</div>
</template>
<script>
import msTr from './msTr.vue';
import msTh from './msTh.vue';
import browserInfoMixin from '@/mixins/common/browserInfoMixin';
export default {
	mixins: [browserInfoMixin],
	name: 'msTreeViewerV2',
	components: {
		msTr,
		msTh,
	},
	props: {
		data: {
			type: Array,
			default: () => [],
		},

		//Cấu hình các cột truyền vào
		columns: {
			type: Array,
			default: () => [],
		},
		isShowExpanded: {
			type: Boolean,
			default: true,
		},
	},
	created() {
		const me = this;
		me.initColumns();
		me.initData();
	},
	computed: {
		dataView() {
			const me = this;
			return me.datax.filter((item) => {
				return item.isHide == false;
			});
		},

		/**
		 * Sự kiện từ 1 dòng dữ liệu emit ra ngoài
		 */
		listeners() {
			const me = this;
			return {
				click: (dataRow, event) => {
					event.target.focus();
					me.$emit('click', dataRow, event);
				},
				dblclick: (dataRow, event) => {
					me.$emit('dblclick', dataRow, event);
				},
			};
		},
	},
	watch: {
		columns: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.initColumns();
			},
		},
		data: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (
					newVal.length <= 0 ||
					(newVal.length > 0 && newVal.every((x) => x.isHide === true))
				) {
					me.isNoData = true;
				} else {
					me.isNoData = false;
				}

				// Nếu props data truyền vào thay đổi thì datax cũng phải thay đổi theo
				if (me.datax !== me.data) {
					me.initData(newVal);
				}
			},
		},
	},
	data() {
		return {
			columnx: [],
			datax: [],
			isNoData: true,
		};
	},
	methods: {
		/**
		 * Khởi tạo dữ liệu ban đầu cho grid
		 * columns truyền vào mặc định là columns trong props có thể truyền cấu hình khác từ ngoài vào
		 */
		initColumns(columns = this.columns) {
			const me = this;
			me.columnx = columns ? columns : me.columns;
			if (!me.columnx) {
				me.columnx = [];
			}
		},
		initData(data = this.data) {
			const me = this;
			me.isNoData = false;
			me.datax = data;
		},
		handlerAction(data) {
			const me = this;
			me.$emit('dataAction', data);
		},
	},
};
</script>
<style lang="scss">
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
	.ms-tree-viewer {
		overflow: auto;
	}
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
.ms-tree-viewer {
	height: 100%;
	padding-left: 16px;
	table {
		height: 100%;
		tbody {
			display: block;
			overflow-y: scroll;
			height: calc(100% - 32px);
		}
		thead,
		tbody tr {
			display: table;
			width: 100%;
			table-layout: fixed;
		}
		thead {
			width: calc(100% - 16px);
		}
	}
}
.no-data {
	text-align: center;
	font-size: 16px;
	padding: 10px 0;
}

.ms-thead-firefox {
	position: sticky;
	top: 0;
	z-index: 1;
	width: 100% !important;
}

@media screen and (max-width: 1024px) {
	.ms-tree-viewer {
		overflow: auto;
	}
}
</style>